import { ca } from '@cian/analytics';

interface ITrackSlidePhotoParams {
  sc: object;
  products: unknown;
  page: Record<string, unknown>;
}

export function trackSlidePhoto({ sc, products, page }: ITrackSlidePhotoParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'slide_photo',
    label: 'from_listing_in_map',
    sc,
    products,
    page,
  });
}
